import { useAtomValue } from 'jotai';
import { LoginModalProps } from 'src/components/LoginModal';
import { LoginModalType, loginModalTypeAtom } from 'src/stores/register/atoms';
import LoginEntry from './LoginEntry';
import PhoneNumberLogin from './PhoneNumberLogin';
import SocialLogin from './SocialLogin';
import SocialRegister from './SocialRegister';
const AzarLoginModal = (props: LoginModalProps) => {
  const loginModalType = useAtomValue(loginModalTypeAtom);
  switch (loginModalType) {
    case LoginModalType.LOGIN_ENTRY:
      return <LoginEntry {...props} />;
    case LoginModalType.SOCIAL_LOGIN:
      return <SocialLogin />;
    case LoginModalType.SOCIAL_REGISTER:
      return <SocialRegister />;
    case LoginModalType.PHONE_NUMBER_LOGIN:
      return <PhoneNumberLogin />;
  }
};
export default AzarLoginModal;